<template>
    <div class="issue-button d-inline-block">
        <b-input-group>
            <b-button variant="primary" class="no-right-round d-inline-block" @click="click">
                <slot/>
            </b-button>
            <b-badge class="no-left-round d-inline-block d-inline-flex align-items-center" :variant="variant">
                <strong class="font-weight-bold" style="font-size: 1.5em">
                    {{ text }}
                </strong>
            </b-badge>
        </b-input-group>
    </div>
</template>

<script>
export default {
    name: 'IssueButton',
    props: {
        label: String,
        to: String,
        issueCount: Number,
    },
    computed: {
        text () {
            return this.issueCount ?? '-'
        },
        variant () {
            return this.issueCount ? 'danger' : 'success'
        }
    },
    methods: {
        click () {
            if (this.to) {
                this.$router.push(this.to)
            }
            this.$emit('click')
        }
    }

}
</script>

<style scoped>
.no-right-round {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.no-left-round {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

</style>